export const isStringNilOrBlank = (stringVal: string | null | undefined) => {
  return stringVal === null || stringVal === undefined || stringVal === '';
};

export const isNil = (val: any | null | undefined): boolean => {
  return val === null || val === undefined;
};

// https://github.com/sindresorhus/escape-string-regexp
export const escapeStringRegexp = (s: string) => {
  if (typeof s !== 'string') {
    throw new TypeError('Expected a string');
  }

  // Escape characters with special meaning either inside or outside character sets.
  // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
  return s.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};

export const pluralize = (quantity, word) => {
  return quantity === 1 ? word : `${word}s`;
};

export const getPageResultsText = (isLoading: boolean, itemsCount: number | null) => {
  if (!isLoading && itemsCount !== null && itemsCount > 0) {
    return `(${itemsCount} ${itemsCount === 1 ? 'result' : 'results'} found)`;
  }

  if (!isLoading && itemsCount === 0) {
    return '(no results found)';
  }

  return 'Loading...';
};

export const stripHtml = (html: string): string => {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').trim();
};

export const isHtml = (str: any): boolean => {
  // Handle null, undefined, or empty strings
  if (!str || typeof str !== 'string') {
    return false;
  }

  // Trim whitespace
  const trimmed = str.trim();

  // Check for HTML tags using regex
  const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;

  // Check for HTML entities
  const htmlEntityRegex = /&[a-zA-Z0-9#]+;/;

  return htmlTagRegex.test(trimmed) || htmlEntityRegex.test(trimmed);
};

export const removeAllLineBreaks = (str: string): string => {
  return str.replace(/[\r\n]/g, '');
};
